<template>
  <div id="app">
    <div id="hgea"></div>
    <router-view />
    <div id="fgea"></div>
  </div>
</template>

<script>
import NavBar from "./components/NavBar";

export default {
  name: "App",
  components: {
    NavBar,
  },
};
</script>
